import { render } from "./ModalLead.vue?vue&type=template&id=615e1768"
import script from "./ModalLead.vue?vue&type=script&lang=js"
export * from "./ModalLead.vue?vue&type=script&lang=js"

import "./ModalLead.vue?vue&type=style&index=0&id=615e1768&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__